import React, { useState } from 'react';
import SPAButton from '../shared/SPAButton';
import SPAInput from '../shared/SPAInput';
import { Field, hintClass, panelClass } from '../shared/formPanel';
import IdentityPicker from './IdentityPicker';
import { SetUserLimitInput } from './useAIPolicy';

interface SetUserLimitFormProps {
  identity: string;
  isSaving: boolean;
  onIdentityChange: (identity: string) => void;
  onSubmit: (input: SetUserLimitInput, onSaved: () => void) => void;
}

const SetUserLimitForm = ({
  identity, isSaving, onIdentityChange, onSubmit,
}: SetUserLimitFormProps) => {
  const [daily, setDaily] = useState('');
  const [rpm, setRpm] = useState('');

  // The gateway rejects a user limit that sets neither, so the button waits for one.
  const submittable = identity.trim() !== '' && (daily.trim() !== '' || rpm.trim() !== '') && !isSaving;

  const submit = () => {
    onSubmit({
      daily_limit_usd: daily.trim() || undefined,
      identity: identity.trim(),
      requests_per_minute: rpm.trim() || undefined,
    }, () => {
      onIdentityChange('');
      setDaily('');
      setRpm('');
    });
  };

  return (
    <div className={panelClass}>
      <div className="tw-grid tw-grid-cols-1 tw-gap-x-5 tw-gap-y-4 md:tw-grid-cols-2">
        <Field htmlFor="user-search" label="User">
          <IdentityPicker inputId="user-search" value={identity} onSelect={onIdentityChange} />
        </Field>
        <Field hint="Or type one directly, e.g. Sysadmin-1234" htmlFor="user-identity" label="Identity">
          <SPAInput
            className="tw-font-mono"
            id="user-identity"
            value={identity}
            onChange={e => onIdentityChange(e.target.value)}
          />
        </Field>
        <Field htmlFor="user-daily" label="$ / day">
          <SPAInput
            id="user-daily"
            inputMode="decimal"
            placeholder="Default"
            value={daily}
            onChange={e => setDaily(e.target.value)}
          />
        </Field>
        <Field htmlFor="user-rpm" label="Req / min">
          <SPAInput
            id="user-rpm"
            inputMode="numeric"
            placeholder="Default"
            value={rpm}
            onChange={e => setRpm(e.target.value)}
          />
        </Field>
      </div>
      <div
        className={
          'tw-mt-6 tw-flex tw-flex-wrap tw-items-center tw-justify-end tw-gap-2 tw-border-0 tw-border-t '
          + 'tw-border-solid tw-border-spa-border-secondary tw-pt-5'
        }
      >
        <span className={`${hintClass} tw-mr-auto tw-mt-0`}>
          A blank field leaves that limit on the default. User limits do not expire.
        </span>
        <SPAButton disabled={!submittable} variant="primary" onClick={submit}>
          Save limit
        </SPAButton>
      </div>
    </div>
  );
};

export default SetUserLimitForm;
